import BillSwitchProductIntroScreen from 'features/billSwitch/screens/BillSwitchProductIntroScreen/BillSwitchProductIntroScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function BillSwitchIntroPage() {
  return (
    <PinwheelContextProvider>
      <BillSwitchProductIntroScreen />
    </PinwheelContextProvider>
  );
}
